/* eslint-disable jsx-a11y/anchor-is-valid */
import {useEffect, useState} from 'react'
import {Modal} from 'react-bootstrap'
import axios from 'axios'
import Swal from 'sweetalert2'
import firebase from '../../../firebase/FirebaseConfig'
import {useUser} from '../../../modules/newauth/UserContext'

const AddDeviceNoteModal = ({
  showMadalAddDeviceNote,
  setShowMadalAddDeviceNote,
  trigger,
  setTrigger,
}) => {
  const [deviceName, setDeviceName] = useState('')
  const [deviceId, setDeviceId] = useState('')
  const [note, setNote] = useState('')
  const [noteHeader, setNoteHeader] = useState('')
  const {user} = useUser()

  const closeModal = () => {
    setShowMadalAddDeviceNote(false)
    setDeviceName('')
    setDeviceId('')
    setNote('')
  }

  const handleSubmit = async () => {
    Swal.fire({
      title: 'Loading...',
      text: 'Please wait',
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading()
      },
    })

    try {
      const db = firebase.firestore()
      const deviceNoteRef = db.collection('deviceNotes')

      await deviceNoteRef.add({
        deviceName: deviceName,
        deviceId: deviceId,
        note: note,
        noteHeader: noteHeader,
        createdAt: firebase.firestore.FieldValue.serverTimestamp(),
        createdBy: user?.userId,
      })

      Swal.fire({
        icon: 'success',
        title: 'Success',
        text: 'Device note added successfully',
      })

      setTrigger(!trigger)
      closeModal()
    } catch (error) {
      console.error('Error adding device note:', error)
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: 'Failed to add device note. Please try again.',
      })
    }
  }

  return (
    <>
      <Modal show={showMadalAddDeviceNote} onHide={() => closeModal()} size='lg'>
        <Modal.Header>
          <Modal.Title>
            <h3 className='fw-600'>Add new device note</h3>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className='p-2'>
            <div className='row'>
              <div className='col-6 mb-5'>
                <label className='form-label'>Device Name</label>
                <input
                  type='text'
                  className='form-control'
                  value={deviceName}
                  onChange={(e) => setDeviceName(e.target.value)}
                />
              </div>
              <div className='col-6 mb-5'>
                <label className='form-label'>Device ID</label>
                <input
                  type='text'
                  className='form-control'
                  value={deviceId}
                  onChange={(e) => setDeviceId(e.target.value)}
                />
              </div>

              <div className='col-12 mb-5'>
                <label className='form-label'>Note Header</label>
                <input
                  type='text'
                  className='form-control'
                  value={noteHeader}
                  onChange={(e) => setNoteHeader(e.target.value)}
                />
              </div>

              <div className='col-12 mb-5'>
                <label className='form-label'>Note</label>
                <input
                  type='text'
                  className='form-control'
                  value={note}
                  onChange={(e) => setNote(e.target.value)}
                />
              </div>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <button className='btn btn-primary' onClick={() => handleSubmit()}>
            Submit
          </button>
          <button className='btn btn-secondary' onClick={() => closeModal()}>
            ปิด
          </button>
        </Modal.Footer>
      </Modal>
    </>
  )
}

export {AddDeviceNoteModal}
